import axios from "axios";
import { baseUrl } from "../util";

export const getBusinessCentralAuth = () => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/auth-business-central",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (response.data.auth_url) {
        window.location.href = response.data.auth_url;
      }
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getAdminConsentBusinessCentral = () => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/admin-consent-business-central",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (response.data.admin_consent_url) {
        window.location.href = response.data.admin_consent_url;
      }
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getBusinessCentralCallback = (code) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/auth-business-central/callback/?code=" + code,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      localStorage.setItem("business_central_token", response.data);
    })
    .catch(function (error) {
      console.log(error);
    });
};
